import FormTrab from './FormTrab/FormTrab';
import FormProv from './FormProv/FormProv';
import FormDir from './FormDir/FormDir';
import FormTravel from './FormTravel/FormTravel';
import FormSoc from './FormSoc/FormSoc';
import FormGift from './FormGift/FormGift';
import FormFP from './FormFP/FormFP';

export const FormTrabPage = FormTrab;
export const FormProvPage = FormProv;
export const FormDirPage = FormDir;
export const FormTravelPage = FormTravel;
export const FormSocPage = FormSoc;
export const FormGiftPage = FormGift;
export const FormFPPage = FormFP;